
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aplikacje-mobilne-i-webowe",
      function () {
        return require("private-next-pages/aplikacje-mobilne-i-webowe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aplikacje-mobilne-i-webowe"])
      });
    }
  